var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"button-type":"ghost","icon":"trash","icon-height":"16px","icon-width":"16px","viewBox":"0 0 24 24","just-icon":""},on:{"click":function($event){return _vm.invokeParentMethod('delete', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }